import {
  initializeApp,
  getApps,
  FirebaseOptions,
  FirebaseApp,
} from 'firebase/app'

// Initialize Firebase
const firebaseApp = (firebaseConfig: FirebaseOptions): FirebaseApp =>
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]

export default firebaseApp
